import script from "./PreStream.vue?vue&type=script&setup=true&lang=js"
export * from "./PreStream.vue?vue&type=script&setup=true&lang=js"

import "./PreStream.vue?vue&type=style&index=0&id=508adc94&scoped=true&lang=css"

import exportComponent from "/home/artur/Documents/bemyvega-gitlab/platform-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508adc94"]])

export default __exports__